import React from 'react'

let Page404 = () => (
    <div>
        <h1>Page not found</h1>
    </div>
)

export default Page404
